import { gql } from '@apollo/client';

export const UserCollectionQuery = gql`
    query UserCollection($collectionGuid: ID) {
        userCollection(collectionGuid: $collectionGuid) {
            guid
            name
            dateCreated
            artworkUrl
            userId
            sampleCount
            slug
        }
    }
`;

export const DeleteUserCollectionMutation = gql`
    mutation DeleteUserCollection($collectionGuid: ID) {
        deleteUserCollection(collectionGuid: $collectionGuid)
    }
`;

export const UserCollectionsFeedQuery = gql`
    query UserCollectionsFeed(
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        userCollectionsFeed(
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            feed(take: $take, page: $page, query: $query, offset: $offset) {
                guid
                name
                dateCreated
                artworkUrl
                userId
                sampleCount
                slug
            }
            meta {
                totalRecords
                totalSampleRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }
        }
    }
`;

export const PaginatedUserCollectionsQuery = gql`
    query PaginatedUserCollections(
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedUserCollections(
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                guid
                name
                dateCreated
                artworkUrl
                userId
                sampleCount
                slug
            }
            meta {
                totalRecords
                totalSampleRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }
        }
    }
`;

export const PaginatedUserCollectionSamplesQuery = gql`
    query PaginatedUserCollectionSamples(
        $collectionGuid: ID
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedUserCollectionSamples(
            collectionGuid: $collectionGuid
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                guid
                name
                bpm
                duration
                pack {
                    artworkUrl
                    guid
                    name
                    slug
                    artist {
                        guid
                        slug
                    }
                    label {
                        guid
                        slug
                    }
                }
                sampleType
                key {
                    code
                    root
                    quality
                }
                isFavorited
                isDownloaded
                isRecommendationFiller
                waveformUrl
                credits
                instruments {
                    code
                    isFamily
                    subInstruments {
                        code
                    }
                }
                tags {
                    code
                }
            }
            meta {
                totalRecords
                totalSampleRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }

            next {
                skip
            }
        }
    }
`;

export const EditUserCollectionMutation = gql`
    mutation EditUserCollection($collectionGuid: ID, $name: String) {
        editUserCollection(collectionGuid: $collectionGuid, name: $name)
    }
`;

export const CreateUserCollectionMutation = gql`
    mutation CreateUserCollection($name: String, $sampleCount: Int) {
        createUserCollection(name: $name, sampleCount: $sampleCount) {
            guid
            name
        }
    }
`;

export const AddSamplesToUserCollectionMutation = gql`
    mutation AddSamplesToUserCollection($sampleIds: [ID], $collectionGuid: ID) {
        addSamplesToUserCollection(
            sampleIds: $sampleIds
            collectionGuid: $collectionGuid
        ) {
            guid
        }
    }
`;

export const RemoveSamplesFromUserCollectionMutation = gql`
    mutation RemoveSamplesFromUserCollection(
        $sampleIds: [ID]
        $collectionGuid: ID
    ) {
        removeSamplesFromUserCollection(
            sampleIds: $sampleIds
            collectionGuid: $collectionGuid
        ) {
            guid
        }
    }
`;
